import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { CategoryFormValues } from "src/models/Category.model";
import {
  useGetCategoryByIdQuery,
  useUpdateCategoryByIdMutation,
} from "src/services/CategoryService";
import ExpenseCategoriesForm from "../Layouts/CategoryForm";

type Props = {
  onClose: () => void;
  selectedCategoryId: string;
};

const EditCategoryWrapper = ({ onClose, selectedCategoryId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetCategoryByIdQuery(selectedCategoryId);
  const [updateCategoryById] = useUpdateCategoryByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: CategoryFormValues = {
    categoryName: items?.categoryName || "",
    rank: items?.rank || "",
    categoryCode: items?.categoryCode || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    categoryName: string().required("Please enter category name"),
    categoryCode: string().required("Please enter category code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: CategoryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CategoryFormValues>
  ) => {
    const payload = {
      categoryName: values.categoryName,
      rank: Number(values.rank),
      categoryCode: values.categoryCode,
    };
    updateCategoryById({
      id: selectedCategoryId,
      body: payload,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ExpenseCategoriesForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCategoryWrapper;
